"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of ProductSuppliers
 * @author Adam Drda
 */


var ProductSuppliersConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductSuppliersConverter, _DataObjectConverter_);

  function ProductSuppliersConverter() {
    _classCallCheck(this, ProductSuppliersConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSuppliersConverter).apply(this, arguments));
  }

  return ProductSuppliersConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductSuppliersConverter = ProductSuppliersConverter;